$(document).ready(function() { 
	var currentPage = 1;
	//$('.sort-bar').hide(); // 정렬 바 숨기기
	$('.sort-inner').hide();
	var pageCnt = 0;
	var appData= null;
	var imgElement = null;
	if(!document.querySelector('.GPC0166')) return false;
	var appSlider = {
        init : function(){
            $('#modal-AppDetail').on('shown.bs.modal', function (e) {
            	 appSlider.popSlick(e.relatedTarget.id);
            });
            $('#modal-AppDetail').on('hidden.bs.modal', function (e) {
                appSlider.unpopSilck();
            });
        },
        popSlick : function(id){
        	var appId = id;
            console.log("appId", appId);
            var url = "/"+COUNTRY_CODE+"/mkt/ajax/lgapps/retrieveLgAppsPopupAjax";
            console.log("url", url);
            // Ajax 요청을 보내고 해당 카테고리의 앱 리스트를 가져옴
            
            param = {
                    appId: appId
            };
         	// Ajax 요청 보내기
            ajax.noCacheCall(url, param, 'json', function(data) {
                if (data.status == 'success') {
                    appData = data.data[0];

                    // 앱 정보를 화면에 표시
                    $(".modal-title").text(appData.appName);
                    imgElement = document.querySelector('.app-icon img');
	                // src 속성에 이미지 URL 설정
	                imgElement.src = appData.smallIconFile;
                    
                    $(".info__txt").eq(0).text(appData.catName);
                    $(".info__txt").eq(1).text(appData.sellerUsrName);
                    $(".info__txt").eq(2).text(appData.age);

                    /* API를 통해 받은 갯수만큼 HTML 태그 생성으로 로직 변경*/
                    $('.app-slider').empty();
                    var slider = $('<ul class="slider"></ul>');
                    appData.imgFilePathList.forEach(function(image) {
                        var img = $('<li><img src="' + image + '" class="lazyloaded" alt="" aria-hidden="true"></li>');
                        slider.append(img);
                    });

                    // 이미지 슬라이드를 특정 HTML 태그 위치에 적용
                    $('.app-slider').html(slider);

                    // 이미지 슬라이드를 Slick 슬라이더로 초기화
                    slider.slick({
                        arrows: false,
                        listStyle: false, 
                        autoplay: false,
                        infinite: false,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        dots: true,
                        accessibility: false
                    }).on('init', function(event, slick) {
                        // 해당 이벤트가 무슨 역할을 하는지 디자인한테 문의 필요
                        if (slick.$slides.length < 2) {
                            $(this).addClass("least-item")
                        }
                    });
                    /* API를 통해 받은 갯수만큼 HTML 태그 생성으로 로직 변경*/
                    $(".desc__txt").text(appData.detailExpln);
                    // 여기서 모달을 표시하거나 다른 작업을 수행할 수 있습니다.
                    $('#modal-AppDetail').modal('show');
                   
                } else {
                    console.error('Failed to retrieve app details');
                }
            });
            console.log('base slick load')
        },
        unpopSilck : function(){
            if($('.app-slider ul.slider').hasClass('slick-initialized') == true){
            	imgElement.src = null;
            	  $(".info__txt").eq(0).text("");
                  $(".info__txt").eq(1).text("");
                  $(".info__txt").eq(2).text("");
                  $('.app-slider').empty();
                  $(".desc__txt").text("");
                var $slick = $('.app-slider ul.slider').slick('unslick');
	                var appListContainer = $('.app-list__box');
	                
            } else{
                return false
            }
        }
    }
    appSlider.init();
	
    $('.btn-tab').on('click', function(e) {
    	currentPage = 1;
        e.preventDefault();
        //alert("gg");
        // 선택한 카테고리의 href 속성 값을 가져옴
        var tabId = $(this).attr('href');
        var catCodeValue = $(this).attr('data-category-code'); 
        var url = $(this).attr('data-link-ajax-url');
        // Ajax 요청을 보내고 해당 카테고리의 앱 리스트를 가져옴
        
     // POPLUAR 탭인 경우, 필요한 요소를 가려줌
        if (tabId == "app_list999") {
            //$('.app-list__box').hide(); // 앱 리스트 숨기기
            //$('.sort-bar').hide(); // 정렬 바 숨기기
        	$('.sort-inner').hide();
			$(".pagination").css("display","none;");
        }else {
        	//$('.sort-bar').show();
        	$('.sort-inner').show();
			$(".pagination").css("display","");
        }
        
        param = {
                catCode: catCodeValue 
                ,nowPage: '1'
                ,localeCode: COUNTRY_CODE
                ,sort: "3"
        };
        console.log('param::::: ' + param);
        
        //sort 초기화
        $("#appListSort option:eq(0)").prop("selected", true);
        $('#appListSort_chosen').find('.chosen-single span').text($("#appListSort option:eq(0)").text());
        $("#appListSort").trigger("chosen:updated");
        
        ajax.noCacheCall(url, param, 'json', function(data){
            if(data.status == 'success'){
                var appList = data.data[0].appList;
                var appListCnt = data.data[0].appListCnt;
                
                // 앱 리스트를 화면에 표시
                var appListContainer = $('.app-list__box');
                appListContainer.empty();
                
                var appItem = "";
                
                for(var i=0; i<appList.length; i++){
					appItem += '<li class="app-list__item">' +
								   '	<a href="#modal-AppDetail" id="' + appList[i].app_id + '" class="btn-detail" data-toggle="modal" title="Opens in a new layer popup" role="button" data-pop-ajax-url="/'+param.localeCode+'/mkt/ajax/lgapps/retrieveLgAppsPopupAjax">' +
//                                   '    <a href="#modal-AppDetail" data-toggle="modal" title="Opens in a new layer popup" role="button">' +
                                  '        <div class="app-list__img">' +
                                  '            <img src="' + appList[i].app_path + '" class="lazyloaded" alt="" aria-hidden="true">' +
                                  '        </div>' +
                                  '        <div class="app-list__info">' +
                                  '            ' + appList[i].app_name +
                                  '        </div>' +
                                  '    </a>' +
                                  '</li>';
				}
				appListContainer.append(appItem);
                // 결과 개수 업데이트
                $('.sort-result span').html(appListCnt);
                //선택된 카테고리 히든으로 적용
                $('#selectedTabCategory').val(catCodeValue);
                
				// 페이지 셋팅
				var pageInfo = data.data[0].pageInfo;
				var messageInfo = data.data[0].pageInfo;
				if (pageInfo.view = "Y") {
					$(".pagination").css("display","");
					pageCnt = pageInfo.pageCount;
					createProductPage(pageInfo,messageInfo);
				}else {
					$(".pagination ul li").remove();
				}
				
				
            } else {
                console.error('Failed to retrieve app list');
            }
        });
    });
    
    // 페이지네이션 버튼 클릭 시 이벤트
    $(document).on('click','.pagination button', function(){
    	var pageNumber = $(this).val();
        var catCodeValue = $('.btn-tab.active').attr('data-category-code');
        var url = $('.btn-tab.active').attr('data-link-ajax-url');
        currentPage = Number(currentPage);
        if(pageNumber=="prev"){
        	currentPage -= 1;
        	if(currentPage<1){
        		currentPage = 1;
        	}
			param = {
                catCode: catCodeValue 
                ,nowPage: currentPage
                ,sort: $('#appListSort option:selected').val()
                ,localeCode: COUNTRY_CODE
	        };
		}else if(pageNumber=="next"){
			currentPage += 1;
			if(currentPage>pageCnt){
				currentPage=pageCnt;
			}
			param = {
                catCode: catCodeValue 
                ,nowPage: currentPage
                ,sort: $('#appListSort option:selected').val()
                ,localeCode: COUNTRY_CODE
	        };
		}else{
			currentPage = pageNumber;
			param = {
                catCode: catCodeValue 
                ,nowPage: pageNumber
                ,sort: $('#appListSort option:selected').val()
                ,localeCode: COUNTRY_CODE
	        };
		}
    	
       
		console.log('param::::: ' + param);
        ajax.noCacheCall(url, param, 'json', function(data){
            if(data.status == 'success'){
                var appList = data.data[0].appList;
                var appListCnt = data.data[0].appListCnt;
				
				
                
                // 앱 리스트를 화면에 표시
                var appListContainer = $('.app-list__box');
                appListContainer.empty();
                
                var appItem = "";
                
                for(var i=0; i<appList.length; i++){
					appItem += '<li class="app-list__item">' +
								   '	<a href="#modal-AppDetail" id="' + appList[i].app_id + '" class="btn-detail" data-toggle="modal" title="Opens in a new layer popup" role="button" data-pop-ajax-url="/'+param.localeCode+'/mkt/ajax/lgapps/retrieveLgAppsPopupAjax">' +
//                                   '    <a href="#modal-AppDetail" data-toggle="modal" title="Opens in a new layer popup" role="button">' +
                                  '        <div class="app-list__img">' +
                                  '            <img src="' + appList[i].app_path + '" class="lazyloaded" alt="" aria-hidden="true">' +
                                  '        </div>' +
                                  '         <div class="app-list__info">' +
                                  '            ' + appList[i].app_name +
                                  '        </div>' +
                                  '    </a>' +
                                  '</li>';
				}
				appListContainer.append(appItem);
                // 결과 개수 업데이트
                $('.sort-result span').html(appListCnt);
                
                // 페이지 셋팅
				var pageInfo = data.data[0].pageInfo;
				var messageInfo = data.data[0].pageInfo;
				
				// view : 페이지 노출 여부
				if (pageInfo.view = "Y") {
					currentPage = pageInfo.page;
					pageCnt = pageInfo.pageCount;
					createProductPage(pageInfo,messageInfo);
				}else{
					$(".pagination ul li").remove();
				}
				
				
				
            } else {
                console.error('Failed to retrieve app list');
            }
        });
        
        

        
        // 페이지 번호에 따라 앱 리스트를 요청
        // 이 부분은 필요에 따라 구현해야 합니다.
        console.log('Requesting app list for page ' + pageNumber);
    });
    
    // 앱 리스트 클릭 이벤트
    $('#appDetail').on("click", function(e){
    	 e.preventDefault();
    	 let url  = $(this).attr("data-pop-ajax-url");    	 
    	 ajax.noCacheCall(url, param, 'json', function(data){
             if(data.status == 'success'){
                 var appList = data.data[0].appPopupData;
                 
                 // 앱 리스트를 화면에 표시
                 var appListContainer = $('.app-list__box');
                 appListContainer.empty();
                 
                 var appItem = "";
                 
                 for(var i=0; i<appList.length; i++){
 					appItem += '<li class="app-list__item">' +
								   '	<a href="#modal-AppDetail" id="' + appList[i].app_id + '" class="btn-detail" data-toggle="modal" title="Opens in a new layer popup" role="button" data-pop-ajax-url="/'+param.localeCode+'/mkt/ajax/lgapps/retrieveLgAppsPopupAjax">' +
//                                   '    <a href="#modal-AppDetail" data-toggle="modal" title="Opens in a new layer popup" role="button">' +
                                   '        <div class="app-list__img">' +
                                   '            <img src="' + appList[i].app_path + '" class="lazyloaded" alt="" aria-hidden="true">' +
                                   '        </div>' +
                                   '        <div class="app-list__info">' +
                                   '            ' + appList[i].app_name +
                                   '        </div>' +
                                   '    </a>' +
                                   '</li>';
 				}
 				appListContainer.append(appItem);
                 // 결과 개수 업데이트
                 $('.sort-result span').html(appListCnt);
                 //선택된 카테고리 히든으로 적용
                 $('#selectedTabCategory').val(catCodeValue);
                 
 				// 페이지 셋팅
 				var pageInfo = data.data[0].pageInfo;
 				var messageInfo = data.data[0].pageInfo;
 				if (pageInfo.view = "Y") {
 					$(".pagination").css("display","");
 					pageCnt = pageInfo.pageCount;
 					createProductPage(pageInfo,messageInfo);
 				}else {
 					$(".pagination ul li").remove();
 				}
 				
 				
             } else {
                 console.error('Failed to retrieve app list');
             }
         });
    	 
    })
    
    // sort  Onchage Event
	$('#appListSort').on("change",function(){
		//hidden 에 존재하는 현재 선택된 카테고리 적용.
		var catCodeValue = $('.btn-tab.active').attr('data-category-code'); 
		var url = $('.btn-tab.active').attr('data-link-ajax-url');
		param = {
			catCode: catCodeValue 
			,nowPage: '1' //클릭버튼으로 교체 
			,sort: $('#appListSort option:selected').val()
			,localeCode: COUNTRY_CODE
		}
		console.log('param::::: ' + param);
        ajax.noCacheCall(url, param, 'json', function(data){
            if(data.status == 'success'){
                var appList = data.data[0].appList;
                var appListCnt = data.data[0].appListCnt;
                
                // 앱 리스트를 화면에 표시
                var appListContainer = $('.app-list__box');
                appListContainer.empty();
                
                var appItem = "";
                
                for(var i=0; i<appList.length; i++){
					appItem += '<li class="app-list__item">' +
								   '	<a href="#modal-AppDetail" id="' + appList[i].app_id + '" class="btn-detail" data-toggle="modal" title="Opens in a new layer popup" role="button" data-pop-ajax-url="/'+param.localeCode+'/mkt/ajax/lgapps/retrieveLgAppsPopupAjax">' +
//                                   '    <a href="#modal-AppDetail" data-toggle="modal" title="Opens in a new layer popup" role="button">' +
                                  '        <div class="app-list__img">' +
                                  '            <img src="' + appList[i].app_path + '" class="lazyloaded" alt="" aria-hidden="true">' +
                                  '        </div>' +
                                  '        <div class="app-list__info">' +
                                  '            ' + appList[i].app_name +
                                  '        </div>' +
                                  '    </a>' +
                                  '</li>';
				}
				appListContainer.append(appItem);
                // 결과 개수 업데이트
                $('.sort-result span').html(appListCnt);
                
                // 페이지 셋팅
				var pageInfo = data.data[0].pageInfo;
				var messageInfo = data.data[0].pageInfo;
				
				// view : 페이지 노출 여부
				if (pageInfo.view = "Y") {
					currentPage = pageInfo.page;
					pageCnt = pageInfo.pageCount;
					createProductPage(pageInfo,messageInfo);
				}else{
					$(".pagination ul li").remove();
				}
            } else {
                console.error('Failed to retrieve app list');
            }
        });
	})
});

/**
 * 페이징 처리
 * @param {array} pageInfo 페이징 정보
 * @param {array} messageInfo 메시지 정보
 **/
function createProductPage (pageInfo, messageInfo) {
	
	// 페이징 Dom
	var pageDom = "";
	
	// 페이징 그리는 곳 | loopStart : 노출 할 페이지의 시작 번호, loopEnd : 노출 할 페이지의 끝 번호, page : 현재 페이지 번호
	for(var i=pageInfo.loopStart; i<=pageInfo.loopEnd; i++){
		if(pageInfo.page==i){
			pageDom += '<li><button type="button" id="btn'+i+'" value="'+i+'" aria-label="Page '+i+'" class="active" aria-current="page" >'+i+'</button></li>';
		}else{
			pageDom += '<li><button type="button" id="btn'+i+'" value="'+i+'" aria-label="Page '+i+'" >'+i+'</button></li>';
		}
	}
	
	// page 이전버튼, 다음버튼 노출 여부
	if(pageInfo.leftPage){
		$("#prevButton").attr("disabled",false);
	} else{
		$("#prevButton").attr("disabled",true);
	}
	if(pageInfo.rightPage){
		$("#nextButton").attr("disabled",false);
	}else{
		$("#nextButton").attr("disabled",true);
	}
	
	// 페이징 구조 그리는 부분
	//$(".pagination ul").html(pageDom);
	$(".pagination ul li").remove();
	$(".pagination ul").append(pageDom);
	
}
